import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Define a type for the slice state
export interface documentsTableStateState {
  TableState: string
};

// Define the initial state using that type
const initialState: documentsTableStateState = {
  TableState: JSON.stringify({sorting:{sortModel:[{ field:'documentName',sort:'asc'}]}})
};

export const documentsTableStateSlice = createSlice({
  name: 'documentsTableState',
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    updatedocumentsGridState: (state, action: PayloadAction<string | null>) => {
        state.TableState = action?.payload ?? initialState.TableState;
    }
  }
});

export const { updatedocumentsGridState } = documentsTableStateSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const documentsTableState = (state: RootState) => state;
export default documentsTableStateSlice.reducer;